export const img_src = new URL('../img/hero-new.f48a84ba.webp', import.meta.url);

export function LMStudio() {
  return <img src={img_src} alt="LM Studio screenshot" className="w-auto max-h-100 mb-8 self-center rounded-lg shadow-xl" />;
}

# Running Local LLMs: Fast, Free, and Private

<div className="text-xl text-gray-400">
Built with Qwen3-Coder-30B-A3B-Instruct + <a href="https://opencode.ai/" className="text-blue-400 hover:text-blue-300 underline">opencode CLI</a>
</div>

Link to slides: <a href="https://llms-demo.holden.xyz/" className="hover:text-blue-300 underline mb-4">https://llms-demo.holden.xyz</a>

<LMStudio />

<div className="text-gray-300 text-lg mt-auto mb-2">
Jesse Holden | October 2, 2025
</div>